/**
 * RAPORUN DAR EKRAN GÖRÜNÜMÜ — "tablo" (yana kayar) ya da "kart" (11.10.2026,
 * kullanıcı: "yana kayan daha iyi göründü, seçenekli olsun").
 *
 * Varsayılan TABLO. Tercih rapor para birimi gibi `localStorage`da
 * (`raporParaBirimi.ts` ile aynı desen ve gerekçe): bir SUNUM tercihi,
 * portföy hakkında hiçbir şey söylemiyor. Depolama kapalıysa ya da kayıt
 * bozuksa tablo.
 */

export type RaporGorunumu = "tablo" | "kart";

export const VARSAYILAN_RAPOR_GORUNUMU: RaporGorunumu = "tablo";

export const RAPOR_GORUNUM_ANAHTARI = "parafon.raporGorunumu";

export function kayitliRaporGorunumu(): RaporGorunumu {
  try {
    const v = globalThis.localStorage?.getItem(RAPOR_GORUNUM_ANAHTARI);
    return v === "kart" || v === "tablo" ? v : VARSAYILAN_RAPOR_GORUNUMU;
  } catch {
    return VARSAYILAN_RAPOR_GORUNUMU;
  }
}

export function raporGorunumunuKaydet(g: RaporGorunumu): void {
  try {
    globalThis.localStorage?.setItem(RAPOR_GORUNUM_ANAHTARI, g);
  } catch {
    // Depolama kapalı: tercih oturumla sınırlı — kabul edilebilir.
  }
}
